import React from 'react'

const CheckMark = props => (
  <svg width={10} height={8} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.433 0L3.767 5.769.455 3.699 0 4.172 3.767 8 10 .454 9.433 0z"
      fill="#007AFF"
    />
  </svg>
)

export default CheckMark
